import React, { useState } from "react";
import "./logoanimated.css";

const LogoAnimated = ({
  src = "./assets/images/1755small.png",
  alt = "logo 1755",
  width,
  imgStyle,
  imgClassName,
  wrapClassName,
}) => {
  const [uid] = useState(
    () => `wine-bowl-${Math.random().toString(36).slice(2, 9)}`,
  );
  return (
    <span className={`logo-wine ${wrapClassName || ""}`.trim()}>
      <img
        className={imgClassName}
        style={imgStyle}
        width={width}
        src={src}
        alt={alt}
      />
      <svg
        className="logo-wine-overlay"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <defs>
          <clipPath id={uid}>
            <ellipse cx="50" cy="42" rx="18" ry="13" />
          </clipPath>
        </defs>
        <g clipPath={`url(#${uid})`}>
          <g>
            <animateTransform
              attributeName="transform"
              type="translate"
              values="-15 0; 15 0; -15 0"
              dur="5s"
              repeatCount="indefinite"
            />
            <path
              d="M-30,38 Q-22,34 -15,38 T0,38 T15,38 T30,38 T45,38 T60,38 T75,38 T90,38 T105,38 T120,38 T135,38 V60 H-30 Z"
              fill="#5a0d18"
              opacity="0.55"
            />
          </g>
          <g>
            <animateTransform
              attributeName="transform"
              type="translate"
              values="15 0; -15 0; 15 0"
              dur="7s"
              repeatCount="indefinite"
            />
            <path
              d="M-30,40 Q-22,37 -15,40 T0,40 T15,40 T30,40 T45,40 T60,40 T75,40 T90,40 T105,40 T120,40 T135,40 V60 H-30 Z"
              fill="#7a1320"
              opacity="0.5"
            />
          </g>
        </g>
      </svg>
    </span>
  );
};

export default LogoAnimated;
